import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=38480676&scoped=true&"
import script from "./form.js?vue&type=script&lang=js&"
export * from "./form.js?vue&type=script&lang=js&"
import style0 from "./form.scss?vue&type=style&index=0&id=38480676&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38480676",
  null
  
)

export default component.exports